import { Outlet, useOutletContext, useParams } from "react-router-dom";
import Layout from "../../components/Layout";
import Navigation from "../../components/Navigation";
import { useTeamInfoQuery } from "../../__generated__/types-and-hooks";
import PageNotFound from "../PageNotFound";

export interface TeamContext {
  team: Exclude<
    Exclude<
      ReturnType<typeof useTeamInfoQuery>["data"],
      undefined
    >["team_by_slug"],
    undefined | null
  >;
}

export function useTeam() {
  return useOutletContext<TeamContext>();
}

export default function TeamLayout() {
  const { teamSlug } = useParams();
  const teamInfoQuery = useTeamInfoQuery({ variables: { slug: teamSlug! } });
  const team = teamInfoQuery.data?.team_by_slug;
  if (!teamInfoQuery.loading && !team) {
    return <PageNotFound />;
  }

  return (
    <Layout.Root>
      <Layout.SideNav>
        {team && <Navigation teamKind={team.kind as "BRAND" | "AGENCY"} />}
      </Layout.SideNav>
      <Layout.Main sx={{ height: "100dvh" }}>
        {/* {teamInfoQuery.loading && <LinearProgress />} */}
        {teamInfoQuery.data?.team_by_slug && (
          <Outlet
            context={
              {
                team: teamInfoQuery.data?.team_by_slug,
              } satisfies TeamContext & any
            }
          />
        )}
      </Layout.Main>
    </Layout.Root>
  );
}
